import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createSlice } from '@reduxjs/toolkit';
import { currentRunningMission } from '../../../screens/Missions/utils/missionsPerformance';
import { MISSIONS_TYPES } from '../../../screens/Missions/constants';
import { isBattleGameAlreadyClaimed } from '../../../screens/Battles/utils/helpers';
var sliceName = 'MISSIONS';

/**
* @typedef {Object} CurrentMission

* @property {number/null} missionId - Unique identifier for the mission.

* @property {string|null} missionType - The type of the mission (e.g., 'explorer', 'battles').

* @property {number/null} missionGameId - Unique game-related identifier for the mission.

* @property {string|null} counterType - The type of counter (e.g., 'progressCounter', etc.).

* @property {number/null} counterGoal - The numeric goal for the counter.

* @property {number} serverProgress - Progress reported by the server (percentage or actual count).

* @property {number} clientProgress - Progress tracked on the client side (percentage or actual count).

* @property {number|null} endTimestamp - The end time for the mission (as a timestamp).

* @property {string|null} goalMessage - A message describing the goal of the mission.

* @property {string|null} missionStatus - The status of the mission.
*/

/**
 * @typedef {Object} MissionsState
 * @property {CurrentMission} currentMission - Details of the currently active mission.
 * @property {boolean} showMissionsProgressBar - Whether the mission progress bar should be shown.
 */

/**
 * @type {MissionsState}
 */
var initialState = {
  currentMission: {
    missionId: null,
    missionType: null,
    missionGameId: null,
    counterType: null,
    counterGoal: null,
    counterReachdedValue: null,
    serverProgress: 0,
    clientProgress: 0,
    endTimestamp: null,
    goalMessage: null,
    missionStatus: null,
    secondaryCounterType: null,
    secondaryCounterGoal: null,
    secondaryCounterReachdedValue: null
  },
  showMissionsProgressBar: false
};
var updateCurrentMission = function updateCurrentMission(currentMission) {
  var _currentMission$count;
  return {
    missionStatus: currentMission === null || currentMission === void 0 ? void 0 : currentMission.missionStatus,
    missionId: currentMission === null || currentMission === void 0 ? void 0 : currentMission.missionId,
    missionType: currentMission === null || currentMission === void 0 ? void 0 : currentMission.missionType,
    missionGameId: currentMission !== null && currentMission !== void 0 && (_currentMission$count = currentMission.counter) !== null && _currentMission$count !== void 0 && (_currentMission$count = _currentMission$count.params) !== null && _currentMission$count !== void 0 && _currentMission$count.gameIds ? currentMission.counter.params.gameIds[0] : null,
    counterType: currentMission === null || currentMission === void 0 ? void 0 : currentMission.counter.counterType,
    counterGoal: currentMission === null || currentMission === void 0 ? void 0 : currentMission.counter.goal,
    counterReachdedValue: currentMission === null || currentMission === void 0 ? void 0 : currentMission.counter.value,
    endTimestamp: currentMission === null || currentMission === void 0 ? void 0 : currentMission.endTimestamp,
    goalMessage: currentMission.counter.goalMessage,
    secondaryCounterType: null,
    secondaryCounterGoal: null,
    secondaryCounterReachdedValue: null
  };
};
var updateCurrentBattle = function updateCurrentBattle(currentBattle) {
  var _currentBattle$counte, _currentBattle$counte2;
  return {
    missionId: currentBattle === null || currentBattle === void 0 ? void 0 : currentBattle.battlesGameId,
    counterType: currentBattle.counterType,
    counterGoal: currentBattle.goal,
    counterReachdedValue: currentBattle.value,
    endTimestamp: currentBattle.endTimestamp,
    missionType: MISSIONS_TYPES.BATTLES,
    missionGameId: getMissionGameId(currentBattle.counterParams),
    goalMessage: currentBattle.goalMessage,
    missionStatus: currentBattle === null || currentBattle === void 0 ? void 0 : currentBattle.battlesGameStatus,
    missionRank: currentBattle === null || currentBattle === void 0 ? void 0 : currentBattle.rank,
    secondaryCounterType: (currentBattle === null || currentBattle === void 0 || (_currentBattle$counte = currentBattle.counterParams) === null || _currentBattle$counte === void 0 ? void 0 : _currentBattle$counte.secondaryCounterType) || null,
    secondaryCounterGoal: (currentBattle === null || currentBattle === void 0 || (_currentBattle$counte2 = currentBattle.counterParams) === null || _currentBattle$counte2 === void 0 ? void 0 : _currentBattle$counte2.secondaryGoal) || null,
    secondaryCounterReachdedValue: (currentBattle === null || currentBattle === void 0 ? void 0 : currentBattle.secondaryValue) || null
  };
};
var getMissionGameId = function getMissionGameId(counterParams) {
  var gameIds = counterParams === null || counterParams === void 0 ? void 0 : counterParams.gameIds;
  if (!Array.isArray(gameIds) || gameIds.length === 0) return null;
  return gameIds.length === 1 ? gameIds[0] : gameIds;
};
var missionsSlice = createSlice({
  name: sliceName,
  initialState: initialState,
  reducers: {
    missionsRequestData: function missionsRequestData(state, action) {
      if (state.currentMission.missionType !== MISSIONS_TYPES.BATTLES) {
        var currentMission = currentRunningMission(action.payload.missions);
        if (currentMission) state.currentMission = _objectSpread(_objectSpread(_objectSpread({}, state.currentMission), updateCurrentMission(currentMission)), {}, {
          serverProgress: currentMission === null || currentMission === void 0 ? void 0 : currentMission.counter.percentage,
          clientProgress: (currentMission === null || currentMission === void 0 ? void 0 : currentMission.counter.percentage) === 100 ? currentMission === null || currentMission === void 0 ? void 0 : currentMission.counter.percentage : state.currentMission.clientProgress
        });else state.currentMission = initialState.currentMission;
        state.showMissionsProgressBar = !!currentMission;
      }
    },
    missionRequestActionStartMission: function missionRequestActionStartMission(state, action) {
      if (state.currentMission.missionType !== MISSIONS_TYPES.BATTLES) {
        var currentMission = currentRunningMission(action.payload.missions);
        if (currentMission) state.currentMission = _objectSpread(_objectSpread(_objectSpread({}, state.currentMission), updateCurrentMission(currentMission)), {}, {
          clientProgress: 0,
          serverProgress: 0
        });
        state.showMissionsProgressBar = !!currentMission;
      }
    },
    missionRequestActionClaimReward: function missionRequestActionClaimReward(state, action) {
      if (state.currentMission.missionType !== MISSIONS_TYPES.BATTLES) {
        var currentMission = currentRunningMission(action.payload.missions);
        if (currentMission) state.currentMission = _objectSpread(_objectSpread(_objectSpread({}, state.currentMission), updateCurrentMission(currentMission)), {}, {
          clientProgress: (currentMission === null || currentMission === void 0 ? void 0 : currentMission.counter.percentage) > state.currentMission.clientProgress ? currentMission === null || currentMission === void 0 ? void 0 : currentMission.counter.percentage : state.currentMission.clientProgress,
          serverProgress: currentMission.counter.percentage
        });else state.currentMission = initialState.currentMission;
        state.showMissionsProgressBar = !!currentMission;
      }
    },
    setCurrentProgress: function setCurrentProgress(state, action) {
      state.currentMission = _objectSpread(_objectSpread({}, state.currentMission), {}, {
        clientProgress: action.payload
      });
    },
    setCleanCurrentMission: function setCleanCurrentMission(state) {
      state.currentMission = initialState.currentMission;
      state.showMissionsProgressBar = false;
    },
    setShowMissionsProgressBar: function setShowMissionsProgressBar(state, action) {
      state.showMissionsProgressBar = action.payload;
    },
    battlesRequestData: function battlesRequestData(state, action) {
      if (state.currentMission.missionType !== MISSIONS_TYPES.EXPLORER) {
        var _action$payload;
        var currentMission = (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.currentGame;
        var shouldUpdateMission = currentMission && !isBattleGameAlreadyClaimed(currentMission);
        if (shouldUpdateMission) {
          state.currentMission = _objectSpread(_objectSpread(_objectSpread({}, state.currentMission), updateCurrentBattle(currentMission)), {}, {
            clientProgress: currentMission.progress === 100 ? currentMission.progress : state.currentMission.clientProgress,
            serverProgress: currentMission.progress
          });
        } else state.currentMission = initialState.currentMission;
        state.showMissionsProgressBar = shouldUpdateMission;
      }
    },
    battlesRequestActionStartMission: function battlesRequestActionStartMission(state, action) {
      var _action$payload$battl;
      var currentMission = (_action$payload$battl = action.payload.battlesFeatureState) === null || _action$payload$battl === void 0 ? void 0 : _action$payload$battl.currentGame;
      if (currentMission) {
        state.currentMission = _objectSpread(_objectSpread(_objectSpread({}, state.currentMission), updateCurrentBattle(currentMission)), {}, {
          clientProgress: 0,
          serverProgress: 0
        });
      }
      state.showMissionsProgressBar = !!currentMission;
    }
  }
});
var actions = missionsSlice.actions,
  reducer = missionsSlice.reducer;
var missionsRequestData = actions.missionsRequestData,
  setCurrentProgress = actions.setCurrentProgress,
  setCleanCurrentMission = actions.setCleanCurrentMission,
  missionRequestActionStartMission = actions.missionRequestActionStartMission,
  missionRequestActionClaimReward = actions.missionRequestActionClaimReward,
  setShowMissionsProgressBar = actions.setShowMissionsProgressBar,
  battlesRequestData = actions.battlesRequestData,
  battlesRequestActionStartMission = actions.battlesRequestActionStartMission;
export { missionsRequestData, setCurrentProgress, setCleanCurrentMission, missionRequestActionStartMission, missionRequestActionClaimReward, setShowMissionsProgressBar, battlesRequestData, battlesRequestActionStartMission };
export default reducer;